/* ============================================================================
   curated-pin.js  —  Heritage (Horizon) collection pin
   TESTED & WORKING on Heritage/Horizon (desktop + mobile).

   Reads ?first=<handle> (+ optional ?variant=<id>) from the collection URL,
   fetches that product's card via the Section Rendering API, pins it to
   position 1 of the grid, points its links at the clicked variant, and hides
   the natural duplicate only if it would have appeared within the first
   HIDE_WITHIN positions.
   ----------------------------------------------------------------------------
   Requires: sections/pinned-card.liquid  (renders one bare card)
             the loader <script> line inside sections/main-collection.liquid
============================================================================ */

(() => {
  const HIDE_WITHIN = 12;          // hide the natural copy if within first N
  const SECTION_ID  = 'pinned-card'; // = sections/pinned-card.liquid (no .liquid)

  const qp = new URLSearchParams(location.search);
  let first = (qp.get('first') || '').trim();
  if (!first) return;

  // Accept a bare handle OR a full / encoded product URL (Meta deep link).
  let variant = qp.get('variant') || '';
  if (first.includes('/products/') || first.startsWith('http')) {
    try {
      const u = new URL(first, location.origin);
      const segs = u.pathname.split('/').filter(Boolean);
      const i = segs.indexOf('products');
      if (i > -1 && segs[i + 1]) first = segs[i + 1];
      variant = variant || u.searchParams.get('variant') || '';
    } catch (_) {}
  }
  // Normalise to a clean handle.
  first = first.split('?')[0].split('/').filter(Boolean).pop();
  if (!first) return;

  const grid = document.querySelector('ul.product-grid');
  if (!grid) return;

  fetch(`/products/${encodeURIComponent(first)}?section_id=${SECTION_ID}`, { cache: 'force-cache' })
    .then((r) => (r.ok ? r.text() : ''))
    .then((html) => {
      html = (html || '').trim();
      if (!html) return;

      // The Section API wraps output; pull just our <li> out of it.
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const card = tmp.querySelector('li[data-pinned="true"]');
      if (!card) return;

      // 1. Pin to position 1.
      grid.insertAdjacentElement('afterbegin', card);

      // 2. Remove the grey PDP "Back Print" label that only shows on the
      //    standalone-rendered card (grid cards don't have it).
      card.querySelectorAll('.pdp-back-badge').forEach((el) => el.remove());

      const pid = card.getAttribute('data-product-id');
      if (!pid) return;

      // 3. Point the pinned card's links at the clicked variant.
      if (variant) {
        card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
          try {
            const u = new URL(a.href, location.origin);
            u.searchParams.set('variant', variant);
            a.href = u.pathname + u.search;
          } catch (_) {}
        });
      }

      // 4. Remove the natural duplicate only if within the first HIDE_WITHIN.
      //    After the prepend, a child's index == its original 1-based position.
      const dupes = grid.querySelectorAll(`li[data-product-id="${pid}"]`);
      if (dupes.length > 1) {
        const natural = dupes[1]; // dupes[0] is the pinned card
        const idx = Array.prototype.indexOf.call(grid.children, natural);
        if (idx > 0 && idx <= HIDE_WITHIN) natural.remove();
      }
    })
    .catch(() => {
      /* silent: on failure the grid renders normally, just unpinned */
    });
})();